import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: opacity 0.3s ease;
`;

const StyledBackground = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background-color: #111314;
	opacity: 0.5;
`;

export { StyledContainer, StyledBackground };
